import { Buffer } from "buffer";
import { UserActivity, ChangeLog, CredentialResponse, Partition } from "./Types";

export const generateExecutedByValue = (activityItem: UserActivity | ChangeLog, credentials: CredentialResponse): string => {
  let executedByName = activityItem.executedByName;
  if((activityItem.executedBy && activityItem.executedBy.includes(credentials.id))){
    executedByName = "Self";
  }

  let executedByPostfix = "";
  if(activityItem.executedBy?.includes('sso-inbound') || activityItem.partition === Partition.OKTA) {
    executedByPostfix = " (SSO)";
  }
  
  return executedByName ? `${executedByName}${executedByPostfix}` : '-';
}


export const stringToHex = (str: string): string => {
  const buf = Buffer.from(str, "utf8");
  const encodedPassword = buf.toString("hex");
  return encodedPassword;
}